import { refreshAccessToken } from "../api";
import { getAuthInfosFromCookie } from "../utils";
import { APP_ENV } from "../config";
import { extractAuthContextFromJWT } from "../lib/jwt";
import { store } from "../store";
import { setCookie } from "../utils";
let refreshPromise = null;

import {
  setAuthScope,
  setJwtToken,
  setRefreshToken,
  setExpiresIn,
  setTokenCreatedAt,
  setAuthToken,
  setAuthContext,
} from "../store";
export const getValidGoPeopleToken = async (forceRefresh = false) => {
  const auth = getAuthInfosFromCookie();
  if (!auth) throw new Error("No GoPeople auth stored");

  const createdAt = normalizeCreatedAt(auth.createdAt);

  if (!createdAt) {
    console.error("Invalid createdAt:", auth.createdAt);
    throw new Error("Invalid createdAt in auth cookie");
  }

  const expiresAt = createdAt * 1000 + auth.expiresIn * 1000;
  const isTokenValid = auth.jwtToken && expiresAt > Date.now();

  if (!forceRefresh && isTokenValid) {
    return auth.jwt;
  }

  if (refreshPromise) {
    const tokens = await refreshPromise;
    console.log("Using ongoing refresh promise for GoPeople token");
    return tokens.accessToken;
  }
  console.log("Refreshing GoPeople token...");

  refreshPromise = (async () => {
    try {
      const newTokens = await refreshAccessToken(auth.refreshToken);

      const createdAt = Math.floor(Date.now() / 1000);
      console.log("New GoPeople tokens received:", newTokens);
      const authC = extractAuthContextFromJWT(newTokens.accessToken);
      console.log("Extracted auth context from JWT:", authC);

      let dtExpire = new Date();
      dtExpire.setTime(dtExpire.getTime() + newTokens.expiresIn * 1000);

      const dispatch = store.dispatch;

      if (authC) {
        // setAuthContext(authC);
        dispatch(setAuthToken(authC.ttpAccessToken));
      }
      dispatch(setExpiresIn(newTokens.expiresIn));
      dispatch(setTokenCreatedAt(newTokens.createdAt));
      dispatch(setAuthScope(newTokens.scope));
      dispatch(setJwtToken(newTokens.jwtToken));
      dispatch(setRefreshToken(newTokens.refreshToken));

      if (authC?.ttpAccessToken) {
        dispatch(setAuthToken(authC.ttpAccessToken));
      }
      console.log("GoPeople token refreshed");
      console.log("New GoPeople tokens:", newTokens);
      const updatedAuth = {
        ...auth,
        jwt: newTokens.accessToken,
        jwtToken: newTokens.accessToken,
        refreshToken: newTokens.refreshToken,
        expiresIn: newTokens.expiresIn,
        createdAt,
      };

      setCookie(
        `ttp_auth_${APP_ENV}`,
        JSON.stringify(updatedAuth),
        dtExpire,
        "/",
        "unitedassociates.be"
      );
      setCookie(
        `ttp_auth_${APP_ENV}`,
        JSON.stringify(updatedAuth),
        dtExpire,
        "/"
      );

      return newTokens;
    } finally {
      refreshPromise = null;
    }
  })();

  const tokens = await refreshPromise;
  return tokens.accessToken;
};
const normalizeCreatedAt = (createdAtRaw) => {
  if (!createdAtRaw) return null;

  if (typeof createdAtRaw === "number") {
    return createdAtRaw.toString().length === 13
      ? Math.floor(createdAtRaw / 1000)
      : createdAtRaw;
  }

  if (typeof createdAtRaw === "string") {
    const parsed = new Date(createdAtRaw).getTime();
    return isNaN(parsed) ? null : Math.floor(parsed / 1000);
  }

  if (typeof createdAtRaw === "object" && createdAtRaw.date) {
    const parsed = new Date(createdAtRaw.date).getTime();
    return isNaN(parsed) ? null : Math.floor(parsed / 1000);
  }

  return null;
};